import { StyleSheet } from '@react-pdf/renderer';

export const pdfStyles = StyleSheet.create({
  // Styles de base
   fontRegular: { fontFamily: "RobotoRegular" },
  fontLight: { fontFamily: "RobotoLight" },
  fontBold: { fontFamily: "RobotoBold" },
  fontMedium: { fontFamily: "RobotoMedium" },
  blockHonoraire:{
    width: 225,
    maxHeight: 25,
    marginTop: 13,
    marginRight: 0,
    marginLeft: 0,
    flex: 0.5,
    flexDirection: "row",
    border: "1px solid grey",
    borderRadius: 3,
    paddingBottom: 24,
  },
  blockDebours: {
    width: 225,
    maxHeight: 25,
    marginTop: 20,
    marginRight: 0,
    marginLeft: 0,
    flex: 0.5,
    flexDirection: "row",
    border: "1px solid grey",
    borderRadius: 3,
    paddingBottom: 24,
  },
  blockEmoluments: {
    width: 225,
    marginLeft: 0,
    marginRight: 0,
    flexDirection: "column",
    border: "1px solid grey",
    borderRadius: 3,
    minHeight: 60,
    height: "auto",
    maxHeight: 130,
  },
  blockFiscalite: {
    width: 225,
    marginRight: 0,
    marginLeft: 0,
    flex: 0.5,
    flexDirection: "column",
    border: "1px solid grey",
    borderRadius: 3,
    minHeight: 80,
  },
  blockFiscalite2: {
    width: 225,
    marginRight: 0,
    marginLeft: 0,
    flex: 0.5,
    flexDirection: "column",
    border: "1px solid grey",
    borderRadius: 3,
    minHeight: 100,
  },
  blockLeft: {
    position: "relative",
    marginLeft: "10%",
    marginRight: 0,
    width: "100%",
  },
  blockRight: {
    position: "relative",
    marginLeft: 0,
    marginRight: "5%",
    width: "100%",
  },
  bodyCtnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    alignContent: "space-between",
    marginTop: 15,
    width: "100%",
  },
  bodyFooterMedium: {
    fontFamily: "RobotoMedium",
    fontSize: 8,
    marginTop: 10,
    textAlign: "justify",
  },
  bodyFooterLaw:{
    fontFamily: "RobotoLight",
    fontSize: 6,
    marginTop: 10,
    textAlign: "justify",
    textIndent: 25,
  },
  bodyFooterLawMargin:{
    fontFamily: "RobotoLight",
    fontSize: 6,
    textAlign: "justify",
  },
  bodyFooterLawBold:{
    fontFamily: "RobotoBold",
    fontSize: 6,
    marginTop: 10,
    textAlign: "justify",
  },
  bodyFooterCtn: {
    width: "80%",
    marginLeft: "10%",
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    objectPosition: "bottom",
  },
  bodyFooterLight: {
    fontFamily: "RobotoLight",
    fontSize: 6,
    marginTop: 5,
  },
  bodyFooterMapped: {
    fontSize: 8,
    marginTop: 4,
  },
  bodyFooterMappedItalic: {
    fontSize: 8,
    marginTop: 4,
    fontFamily: "RobotoItalic",
  },
  bodyFooterMappedTitle: {
    fontSize: 8,
    marginTop: 4,
    fontFamily: "RobotoBold",
  },
  containerTitleSimu: {
    position: "relative",
    marginTop: 20,
    marginRight: "auto",
    marginLeft: "auto",
    width: "75%",
    maxHeight: 50,
    overflow: "hidden",
  },
  ctnChart: {
    position: "absolute",
    bottom: 220,
    width: 170,
    height: 180,
    left: "35%",
  },
  chartImage: {
    width: "100%",
  },
  ctnEmol: {
    width: 150,
    height: 20,
    fontFamily: "RobotoRegular",
    textAlign: "left",
    fontSize: 10,
    paddingLeft: 5,
  },
  ctnResultatsNb: {
    width: "60%",
    height: 25,
    fontFamily: "RobotoBold",
    fontSize: 12,
    paddingTop: 5,
    textAlign: "right",
  },
  ctnResultatsNb2: {
    width: 75,
    fontFamily: "RobotoBold",
    fontSize: 12,
    textAlign: "right",
  },
  ctnResultatsNb3: {
    width: "60%",
    height: 20,
    fontFamily: "RobotoBold",
    fontSize: 12,
    paddingTop: 1,
    textAlign: "right",
  },
  ctnResultatsNbTop: {
    width: "60%",
    height: 25,
    fontFamily: "RobotoBold",
    fontSize: 12,
    paddingTop: 5,
    borderBottom: "1px solid grey",
    textAlign: "right",
  },
  ctnResultatsTxt: {
    width: "100%",
    flex: 1,
    flexDirection: "row",
    justifyItems: "right",
    marginBottom: 25,
  },
  ctnResultatsTxt2: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    alignContent: "space-between",
    justifyContent: "space-between",
  },
  debours: {
    width: 100,
    height: 25,
    fontFamily: "RobotoBold",
    fontSize: 12,
    paddingLeft: 5,
    paddingTop: 5,
    backgroundColor: "rgba(214,127,98,0.71)",
    borderTopLeftRadius: 2,
    borderBottom: "1px solid grey",
  },
  honoraire: {
    width: 100,
    height: 25,
    fontFamily: "RobotoBold",
    fontSize: 12,
    paddingLeft: 5,
    paddingTop: 5,
    backgroundColor: "#B0DB9C",
    borderTopLeftRadius: 2,
    borderBottom: "1px solid grey",
  },
  dmtgResults: {
    fontWeight: "normal",
    fontSize: 10,
    paddingTop: 5,
    paddingBottom: 5,
  },
  representantTitle: {
    fontSize: 10,
    fontFamily: "RobotoBold",
    color: "#3f6f8f",
    backgroundColor: "#e6f1f8",
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 8,
    marginTop: 5,
  },
  donataireBlock: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: "5px",
    marginBottom: "15px",
    width: "100%",
    fontFamily: "RobotoBold",
  },
  donataireTitle: {
    width: "30%",
    maxWidth: 90,
    fontSize: 13,
    color: "white",
    backgroundColor: "#9d72a9",
    textAlign: "center",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 40,
  },
  donateurBlock: {
    border: "1px solid #71add9",
    borderRadius: 3,
    margin: 10,
    maxWidth: 180,
    minWidth: 150,
    boxSizing: "border-box",
  },
  donateurResults: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  donateurTitle: {
    width: "100%",
    textAlign: "center",
    color: "white",
    backgroundColor: "#71add9",
    fontSize: 12,
    padding: 10,
  },
  emoluments: {
    width: "70%",
    height: 25,
    fontFamily: "RobotoBold",
    fontSize: 12,
    paddingLeft: 5,
    paddingTop: 5,
    backgroundColor: "rgba(164,148,128,0.8)",
    borderTopLeftRadius: 2,
    borderBottom: "1px solid grey",
  },
  globalBlock: {
    display: "flex",
    flexDirection: "row",
    marginTop: "5px",
    marginBottom: "15px",
    border: "1px solid #9d72a9",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
  },
  headerAdress: {
    fontSize: 10,
    fontFamily: "RobotoRegular",
  },
  headerDate: {
    marginTop: 10,
    fontSize: 9.5,
    fontFamily: "RobotoRegular",
  },
  headerName: {
    fontSize: 11,
    fontFamily: "RobotoBold",
    wordBreak: "keep-all",
  },
  headerRight: {
    marginLeft: "50%",
    marginTop: 5,
    marginRight: 40,
    fontSize: 12,
    textAlign: "right",
    lineHeight: 1.5,
    wordBreak: "keep-all",
  },
  headerLeft: {
    marginLeft: 40,
    marginTop: 15,
    marginRight: "50%",
    fontSize: 12,
    textAlign: "Left",
    lineHeight: 1.5,
    wordBreak: "keep-all",
  },
  heritierBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: 5,
    marginBottom: 15,
    border: "1px solid #71ADD9",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
    height: "auto",
  },
  conjointSurvivantBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: 5,
    marginBottom: 15,
    border: "1px solid #70B77E",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
    height: "auto",
  },
  heritierBlock2: {
    flex: 1,
    margin: 10,
    maxWidth: "100%",
  },
  heritierTitle: {
    height: "100%",
    width: "auto",
    fontSize: 13,
    color: "white",
    backgroundColor: "#71ADD9",
    textAlign: "center",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
  },
  conjointSurvivantTitle: {
    height: "100%",
    width: "auto",
    fontSize: 13,
    color: "white",
    backgroundColor: "#70B77E",
    textAlign: "center",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
  },
  importantInfoTitle: {
    paddingTop: 10,
    paddingLeft: 15,
    paddingBottom: 10,
    width: "100%",
    borderBottom: "1px solid grey",
    backgroundColor: "rgba(94,145,182,0.8)",
  },
  otherResultsBlock: {
    padding: "15 0 10 15",
    width: "90%",
  },
  otherResults: {
    fontSize: 12,
    paddingTop: 10,
    paddingBottom: 10,
  },
  page: {
    paddingTop: 20,
    paddingBottom: 50,
  },
  rappel: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    columnGap: 50,
    width: "50%",
    height: 150,
    marginLeft: "10%",
    marginRight: "10%",
    position: "absolute",
    bottom: 60,
  },
  rappelBlockDonataire: {
    marginTop: 5,
    marginBottom: 10,
  },
  rappelDMTG: {
    position: "relative",
    width: "80%",
    marginLeft: "10%",
    // marginTop: 175,
    marginTop: 30,
    marginBottom: 50,
    paddingBottom: 150,
  },
  rappelDonateurTitle: {
    fontSize: 10,
    marginTop: 5,
    fontWeight: "bold",
    color: "rgb(157 114 169)",
  },
  rappelDonataireTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#71ADD9",
  },
  rappelConjointSurvivantTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#70B77E",
  },
  remarque: {
    border: "1px solid grey",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoRegular",
    fontSize: 10,
    marginTop: 15,
    lineHeight: 2,
    maxHeight: 40,
    overflow: "hidden",
  },
  remarqueText: {
    marginTop: 8,
    marginLeft: 5,
  },
  resultatsNb: {
    textAlign: "right",
    position: "relative",
    right: 7,
  },
  resultatsNb2: {
    fontSize: 12,
    textAlign: "right",
    position: "relative",
    right: 7,
  },
  resultsBlock: {
    marginTop: 5,
    marginBottom: 10,
    display: "flex",
    flexWrap: "wrap",
  },
  resultsTitle: {
    fontSize: 14,
    paddingLeft: "10%",
    width: "100%",
    marginBottom: 10,
    marginTop: 15,
  },
  resultatsTxt: {
    width: 100,
    height: 25,
    fontFamily: "RobotoRegular",
    textAlign: "left",
    fontSize: 10,
    paddingLeft: 30,
    paddingTop: 5,
  },
  resultatsTxt2: {
    width: 170,
    height: 20,
    fontFamily: "RobotoRegular",
    textAlign: "left",
    fontSize: 10,
    paddingLeft: 30,
    paddingTop: 1,
  },
  resultatsTxt3: {
    width: 100,
    height: 20,
    fontFamily: "RobotoLight",
    textAlign: "left",
    fontSize: 10,
    paddingLeft: 30,
    paddingTop: 1,
  },
  superEmol: {
    height: "auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
    marginTop: 5,
    marginBottom: 5,
  },
  taxes: {
    width: 100,
    height: 25,
    fontFamily: "RobotoBold",
    fontSize: 12,
    paddingLeft: 5,
    paddingTop: 5,
    backgroundColor: "rgba(71,143,154,0.73)",
    borderTopLeftRadius: 2,
    borderBottom: "1px solid grey",
  },
  titleSimu: {
    fontSize: 13,
    textAlign: "center",
    fontFamily: "RobotoBold",
    wordBreak: "keep-all",
  },
  ObjectConvention: {
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 10,
    fontSize: 10,
    fontFamily: "RobotoBold",
  },
  ttc: {
    border: "1px solid grey",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
    fontSize: 14,
    marginTop: 10,
    height: 45,
  },
  ttcOverflowAuto: {
    overflow: "auto",
    marginTop: 15,
    height: "",
  },
  ttcDetail: {
    border: "1px solid grey",
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
    width: "75%",
    marginLeft: "12.5%",
    fontFamily: "RobotoBold",
    fontSize: 12,
    marginTop: -1,
    height: 50,
  },
  ttcInternCtn: {
    flex: 1,
    flexDirection: "row",
    marginTop: 15,
  },
  ttcInternCtnTight: {
    marginTop: 4,
  },
  ttcLeft: {
    paddingLeft: 5,
    width: "70%",
  },
  ttcRight: {
    paddingRight: 5,
    width: "30%",
    textAlign: "center",
  },
  themeTable: {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 25,
    display: "flex",
    flexDirection: "column",
  },
  themeHeader: {
    width: "100%",
    height: 28,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    textAlign: "center",
  },
     
  themeHeaderDebours: {
    backgroundColor: "#dd9374",
  },
  themeHeaderHonoraires: {
    backgroundColor: "#B0DB9C",
  },
  themeHeaderGrey: {
    backgroundColor: "#e0e0e0",
  },
  themeHeaderText: {
    fontFamily: "RobotoBold",
    fontSize: 10,
    marginTop: "auto",
    marginBottom: "auto",
  },
  detailsContentTable: {
    width: "100%",
    display: "flex",
    fontSize: 8.5,
    flexDirection: "column",
    gap: -5,
  },
  detailsContentTableBorderBottom: {
    borderBottom: "1px solid #eeeae5",
  },
  detailsRow: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 2,
    paddingBottom: 2,
  },
  detailsRowCompact: {
    marginTop: -3,
    marginBottom: -3,
  },
  detailsRowCompactTop: {
    marginTop: -3,
  },
  detailsRowCompactBottom: {
    marginBottom: -3,
  },
  detailsSubjectField: {
    flex: 0.6,
    paddingRight: 4,
    borderRight: "1px solid #eeeae5",
    height: 18,
  },
  detailsSubjectFieldH25: {
    height: 25,
  },
  detailsSubjectFieldH5: {
    height: 5,
  },
  detailsSubjectFieldBorderTop: {
    borderTop: "1px solid #eeeae5",
  },
  detailsSubjectText: {
    width: "100%",
    textAlign: "right",
    marginTop: "auto",
    marginBottom: "auto",
  },
  detailsSubjectTextMedium: {
    fontFamily: "RobotoMedium",
  },
  detailsSubjectTextBold: {
    fontFamily: "RobotoBold",
  },
  detailsBaseField: {
    height: 18,
    flex: 0.2,
    borderRight: "1px solid #eeeae5",
  },
  detailsEmptyCell: {
    height: 18,
    flex: 0.2,
  },
  detailsBaseText: {
    textAlign: "center",
    width: "100%",
    marginTop: 3.8,
    marginBottom: "auto",
  },
  detailsMontantText: {
    flex: 0.2,
    marginTop: 3.8,
    textAlign: "center",
  },
  detailsMontantTextBold: {
    fontFamily: "RobotoBold",
  },
  totalRow: {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    height: 28,
    backgroundColor: "#b5a58e",
    marginTop: 30,
    borderRadius: 4,
    textAlign: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  totalText: {
    fontFamily: "RobotoBold",
    fontSize: 9.5,
    marginTop: "auto",
    marginBottom: "auto",
  },
  totalTextSmallFlex04: {
    fontSize: 9,
    flex: 0.4,
  },
  totalTextMedium: {
    fontFamily: "RobotoMedium",
  },
  signatureTitle: {
    fontFamily: "RobotoBold",
    marginTop: 8,
  },
  signatureLabel: {
    fontFamily: "RobotoBold",
  },
  column: {
    flexDirection: "column",
  },
 persoEmolMainContainer: {
    borderRadius: 5,
    marginTop: 20,
    border: "1px solid #eeeae5",
  },
  persoEmolHeaderContainer: {
    width: "100%",
    height: 24,
    borderBottom: "1px solid #eeeae5",
    backgroundColor: "#eeeae5",
    textAlign: "left",
    fontFamily: "RobotoBold",
    fontSize: 9.5,
  },
  persoEmolColumnsHeader: {
    display: "flex",
    flexDirection: "row",
    paddingBottom: 2,
    borderBottom: "1px solid #eeeae5",
  },
  
  persoEmolColumn1Header: {
    flex: 0.5,
    paddingRight: 4,
    borderRight: "1px solid #eeeae5",
    height: 30,
  },
  
  persoEmolColumn1HeaderText: {
    marginLeft: 30,
    textAlign: "left",
    marginTop: "auto",
    marginBottom: "auto",
    fontWeight: "bold",
  },
  
  persoEmolColumn2Header: {
    height: 30,
    flex: 0.166,
    borderRight: "1px solid #eeeae5",
  },
  
  persoEmolColumn2HeaderTextTop: {
    textAlign: "center",
    width: "100%",
    marginTop: 4,
    fontWeight: "bold",
  },
  
  persoEmolColumn2HeaderTextBottom: {
    textAlign: "center",
    width: "100%",
  },
  
  persoEmolColumn3Header: {
    height: 30,
    flex: 0.166,
    borderRight: "1px solid #eeeae5",
    textAlign: "center",
  },
  
  persoEmolColumn4Header: {
    height: 30,
    flex: 0.166,
    textAlign: "center",
  },
  
  persoEmolColumnHeaderCenteredText: {
    fontWeight: "bold",
    marginTop: "auto",
    marginBottom: "auto",
  },
  fiscaliteTableContainer: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginTop: 40,
    border: "1px solid #d8e9ec",
  },
  
  fiscaliteTableHeader: {
    backgroundColor: "#55a0ab",
    borderBottom: "1px solid #d8e9ec",
  },
  
  fiscaliteSectionHeader: {
    width: "100%",
    height: 24,
    borderBottom: "1px solid #d8e9ec",
    backgroundColor: "#d8e9ec",
    textAlign: "left",
    fontFamily: "RobotoBold",
    fontSize: 9.5,
  },
  persoEmolHeaderText: {
    marginTop: "auto",
    marginBottom: "auto",
    marginLeft: 10,
  }, 
  
  tvaRowContainer: {
    marginTop: -3,
    marginBottom: -3,
  },
  tresorHeaderEmptyColumn: {
    flex: 0.6,
    paddingRight: 4,
  },
  container1: {
    borderRadius: 5,
    marginTop: 40,
    border: "1px solid #eeeae5",
  },
  container2: {
    backgroundColor: "#b5a58e",
    borderBottom: "1px solid #eeeae5",
  },
  
   persoEmolHeader: {
    width: "100%",
    height: 24,
    // borderBottomRightRadius: 4,
    // borderBottomLeftRadius: 4,
    borderBottom: "1px solid #eeeae5",
    backgroundColor: "#eeeae5",
    textAlign: "left",
    fontFamily: "RobotoBold",
    fontSize: 9.5,
  },
  tresorHeaderLeft: {
    flex: 0.6,
    paddingRight: 4,
  },
  tresorHeaderBaseCalc: {
    flex: 0.2,
    borderLeft: "1px solid #eeeae5",
    borderBottom: "1px solid #eeeae5",
    textAlign: "center",
    height: 18,
    marginTop: -3,
  },
  container7Text1: {
    marginTop: 3.8, 
    fontFamily: "RobotoBold",
  },
  totalEmolFormLeft: {
    flex: 0.6,
    paddingRight: 4,
    borderRight: "1px solid #eeeae5",
    borderTop: "1px solid #eeeae5",
    height: 25,
  },
  totalEmolFormMiddle: {
    height: 25,
    flex: 0.2,
    borderRight: "1px solid #eeeae5",
    borderTop: "1px solid #eeeae5",
  },
  totalEmolFormRight: {
    height: 25,
    flex: 0.2,
    borderTop: "1px solid #eeeae5",
  },
  totalEmolFormValue: {
    textAlign: "center",
    fontFamily: "RobotoBold",
    marginTop: 7.3,
  }, 
  container43: {
    width: "100%",
    height: 24,
    borderBottom: "1px solid #eeeae5",
    backgroundColor: "#eeeae5",
    textAlign: "left",
    fontFamily: "RobotoMedium",
    fontSize: 9.5,
  },
  container49: {
    width: "100%",
    height: 24,
    borderBottom: "1px solid #f7e7df",
    backgroundColor: "#f7e7df",
    textAlign: "left",
    fontFamily: "RobotoBold",
    fontSize: 9.5,
  },
  container46Text: {
    width: "100%", 
    textAlign: "right", 
    margin: "auto" 
  },
  container47Text: {
    flex: 0.2, 
    margin: "auto", 
    textAlign: "center"
  },
  container47Text2: {
    flex: 0.2, 
    margin: "auto", 
    textAlign: "center",
    borderRight: "1px solid #eeeae5"
  },
  promesseMiddle: {
    height: 25,
    flex: 0.2,
    borderRight: "1px solid #eeeae5",
  },
  container48: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 2,
    paddingBottom: 2,
    marginBottom: -3
  },
  
  totalEmolFormText: {
    width: "100%",
    textAlign: "right",
    fontFamily: "RobotoMedium",
    margin: "auto",
  },
  
  promesseRight: {
    height: 25,
    flex: 0.2,
  },
  promesseRight1: {
    height: 25,
    flex: 0.4,
  },
  promesseRight1Text: {
    textAlign: "left",
    marginLeft: 52,
    marginTop: 7.3,
  },
  Rightlaw: {
    height: 18,
    flex: 0.2,
  },
  totaltaxation: {
    backgroundColor: "#55a0ab",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  totaltaxationCharge: {
    width: "85%",
    height: 20,
    backgroundColor: "#d8e9ec",
    marginTop: 0,
    borderRadius: 0,
    borderBottom: "1px solid #d8e9ec",
  },
  totaltaxationCharge3: {
    width: "85%",
    height: 20,
    backgroundColor: "#f7e7df",
    marginTop: 0,
    borderRadius: 0,
    borderBottom: "1px solid #f7e7df",
  },
  totaltaxationCharge4: {
    width: "85%",
    height: 20,
    backgroundColor: "#f7e7df",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottom: "1px solid #f7e7df",
  },
  totaltaxationCharge2: {
    width: "85%",
    height: 20,
    backgroundColor: "#d8e9ec",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottom: "1px solid #d8e9ec",
  },
  deboursSup: {
    width: "100%",
    height: 24,
    borderBottom: "1px solid #d8e9ec",
    borderTop: "1px solid #d8e9ec",
    backgroundColor: "#f7e7df",
    textAlign: "left",
    fontFamily: "RobotoBold",
    fontSize: 9.5,
  },
  totaldebours: {
    backgroundColor: "#dd9374",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  totalhoraireTTC: {
    backgroundColor: "#B0DB9C",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  totaltaxationChargeText: {
    fontSize: 9, 
    flex: 0.6, 
    fontFamily: "RobotoMedium" 
  },
  themedebours: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    border: "1px solid #dd9374",
  },

  Totalprevision: {
    backgroundColor: "",
    marginTop: 20,
    border: "1px solid grey",
    paddingTop: 5,
    paddingBottom: 5,
  },
  feeAgreement: {
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginTop: 25,
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
  },
  
  persoEmolRowEven: {
    backgroundColor: "#f8f6f4",
    display: "flex",
    flexDirection: "row",
    // paddingBottom: 4,
  },
  persoEmolRowOdd: {
    display: "flex",
    flexDirection: "row",
    // paddingBottom: 6,
  },
  persoEmolItemNature: {
    flex: 0.5,
    paddingRight: 4,
    borderRight: "1px solid #eeeae5",
    minHeight: 30,
    paddingTop: 0,
    paddingBottom: 6,
    marginTop: 0,
  },
  persoEmolItemNatureText: {
    marginLeft: 5,
    textAlign: "left",
    marginTop: 13,
    fontWeight: "bold",
  },
  persoEmolItemNumero: {
    minHeight: 30,
    flex: 0.166,
    borderRight: "1px solid #eeeae5",
  },
  persoEmolItemNumeroWrapper: {
    marginTop: "auto",
    marginBottom: "auto",
  },
  persoEmolItemNumeroText1: {
    textAlign: "center",
    width: "100%",
    marginTop: 0,
    fontWeight: "bold",
  },
  persoEmolItemNumeroText2: {
    textAlign: "center",
    width: "100%",
  },
  persoEmolItemCout: {
    minHeight: 30,
    flex: 0.166,
    borderRight: "1px solid #eeeae5",
    textAlign: "center",
  },
  persoEmolItemCoutText: {
    fontWeight: "bold",
    marginTop: 0,
  },
  persoEmolItemNombre: {
    minHeight: 30,
    flex: 0.166,
    textAlign: "center",
  },
  persoEmolTotalRow: {
    display: "flex",
    flexDirection: "row",
    marginTop: 5,
    marginBottom: 2,
  },
  persoEmolTotalLeft: {
    flex: 0.5,
    paddingRight: 2,
    borderRight: "1px solid #eeeae5",
    borderTop: "1px solid #eeeae5",
    height: 25,
  },
  totalUsufructRowCustom: {
    width: "85%",
    height: 20,
    backgroundColor: "#eeeae5",
    marginTop: 0,
    borderRadius: 0,
    borderBottom: "1px solid #eeeae5",
  },

  totalhonoraireUsufruct: {
    width: "85%",
    height: 20,
    backgroundColor: "#F1F7EF",
    marginTop: 0,
    borderRadius: 0,
    borderBottom: "1px solid #F1F7EF",
  },
  totalhonoraireUsufruct2: {
    width: "85%",
    height: 20,
    backgroundColor: "#F1F7EF",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottom: "1px solid #F1F7EF",
  },
  
  totalUsufructTextCustom: {
    fontSize: 9,
    flex: 0.65,
    fontFamily: "RobotoMedium",
  },
  
  totalUsufructAmountCustom: {
    fontSize: 9,
    flex: 0.35,
  },
  
  totalNPRowCustom: {
    width: "85%",
    height: 20,
    backgroundColor: "#eeeae5",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottom: "1px solid #eeeae5",
  },
  tresorEmptyMiddle: {
    height: 5,
    flex: 0.2,
    borderRight: "1px solid #eeeae5",
  },
  persoEmolTotalRight: {
    flex: 0.5,
    borderTop: "1px solid #eeeae5",
  },
  totalHonoraires: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    border: "1px solid #B0DB9C",
  },

  tvaHonoraires: {
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
    height: 28,
    backgroundColor: "#e0e0e0",
    marginTop: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    textAlign: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  MaintvaHonoraires: {
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 9,
  },
  MaintvaHonorairesleft: {
    border: "1px solid #333", 
    width: "48%",
    height: 120, 
    padding: 10, 
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  MaintvaHonorairesright: {
    border: "1px solid #333", 
    width: "48%",
    height: 120, 
    padding: 10, 
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  
  Actepret1: {
    height: 18,
    flex: 0.2,
    borderRight: "1px solid #eeeae5",
    borderTop: "1px solid #eeeae5",
  },
  baseRightCol: {
    marginTop: 3.8,
    textAlign: "center",
    fontFamily: "RobotoBold",
  },
  actePretTotalRightCol: {
    height: 18,
    flex: 0.2,
    borderTop: "1px solid #eeeae5",
  },

});
